import { Fragment as e, TransitionGroup as t, computed as n, createBlock as r, createCommentVNode as i, createElementBlock as a, createElementVNode as o, createSlots as s, createTextVNode as c, createVNode as l, defineComponent as u, normalizeClass as d, normalizeStyle as f, openBlock as p, readonly as m, ref as h, renderList as g, renderSlot as _, toDisplayString as v, unref as y, useTemplateRef as b, watch as x, withCtx as S } from "vue";
import { CheckRounded as C, Error as w, IconBase as T, IconSize as E, Info as D, TOP_LAYER_CHANGE_EVENT as O, Times as k } from "@myparcel-frontend/ui";
import { useEventListener as A } from "@vueuse/core";
import { useI18n as j } from "vue-i18n";
//#region src/types/notification.types.ts
var M = {
	Info: "info",
	Success: "success",
	Warning: "warning",
	Error: "alert"
}, N = {
	Full: "full",
	Half: "half"
}, P = { Toaster: "toaster" }, F = { key: 0 }, I = { class: "content flex flex-col grow" }, L = { class: "empty:hidden font-bold" }, R = { class: "body" }, z = /* @__PURE__ */ u({
	__name: "Toast",
	props: {
		id: { default: "" },
		variant: {},
		timeout: { default: 6e3 },
		size: { default: N.Full },
		canClose: { type: Boolean },
		withShadow: { type: Boolean }
	},
	emits: ["remove"],
	setup(e, { emit: t }) {
		let s = e, c = t, u = h(!1), m = () => {
			u.value = !0;
		}, g = () => {
			u.value = !1;
		}, v = () => {
			c("remove", s.id);
		}, b = n(() => s.variant === M.Info), x = n(() => s.variant === M.Error), O = n(() => s.variant === M.Warning), A = n(() => s.variant === M.Success);
		return (t, n) => (p(), a("div", {
			"aria-atomic": "true",
			"aria-live": "polite",
			class: d(["border border-gray-400 flex items-center mb-4 md:text-base overflow-hidden p-4 pointer-events-auto relative rounded-lg transform-gpu", {
				"drop-shadow-md": e.withShadow,
				"pb-5!": !!e.timeout,
				"md:min-w-[400px] md:max-w-3xl md:min-h-[56px]": e.size === y(N).Half,
				"bg-green-100": A.value,
				"bg-blue-100": b.value,
				"bg-yellow-100": O.value,
				"bg-red-100": x.value
			}]),
			"data-test": "toast",
			role: "status",
			onMouseenter: m,
			onMouseleave: g
		}, [
			e.timeout ? (p(), a("div", F, [o("div", {
				class: d(["absolute bottom-0 h-1 left-0 origin-left w-full animate-shrink", {
					"bg-blue": b.value,
					"bg-green": A.value,
					"bg-yellow": O.value,
					"bg-red": x.value
				}]),
				style: f({
					"animation-duration": e.timeout + "ms",
					"animation-play-state": u.value ? "paused" : "running"
				}),
				onAnimationend: v
			}, null, 38), o("div", { class: d(["absolute bottom-0 h-1 left-0 opacity-20 w-full", {
				"bg-blue": b.value,
				"bg-green": A.value,
				"bg-yellow": O.value,
				"bg-red": x.value
			}]) }, null, 2)])) : (p(), a("div", {
				key: 1,
				class: d(["absolute h-full left-0 top-0 w-1", {
					"bg-blue": b.value,
					"bg-green": A.value,
					"bg-yellow": O.value,
					"bg-red": x.value
				}])
			}, null, 2)),
			o("div", { class: d(["flex-none pr-4", {
				"text-blue": b.value,
				"text-green": A.value,
				"text-yellow": O.value,
				"text-red": x.value
			}]) }, [l(y(T), { size: y(E).Normal }, {
				default: S(() => [
					b.value ? (p(), r(y(D), { key: 0 })) : i("", !0),
					x.value ? (p(), r(y(w), { key: 1 })) : i("", !0),
					O.value ? (p(), r(y(w), { key: 2 })) : i("", !0),
					A.value ? (p(), r(y(C), { key: 3 })) : i("", !0)
				]),
				_: 1
			}, 8, ["size"])], 2),
			o("div", I, [o("div", L, [_(t.$slots, "title")]), o("div", R, [_(t.$slots, "default")])]),
			e.canClose ? (p(), a("button", {
				key: 2,
				class: "button close flex-none pl-4",
				type: "button",
				onClick: n[0] ||= (t) => c("remove", e.id)
			}, [l(y(T), {
				class: "cursor-pointer",
				size: y(E).Normal
			}, {
				default: S(() => [l(y(k))]),
				_: 1
			}, 8, ["size"])])) : i("", !0)
		], 34));
	}
}), B = h([]), V = h(0), H = 6e3, U = 3e4;
function W() {
	return {
		notifications: m(B),
		addNotification: ({ id: e, variant: t = M.Info, canClose: n, withShadow: r, body: i, title: a, timeout: o = H, location: s = P.Toaster }) => {
			let c = e;
			c ||= (V.value++, V.value.toString());
			let l = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : Math.min(o, U);
			B.value.some((e) => e.id === c) || B.value.unshift({
				id: c,
				body: i,
				variant: t,
				title: a,
				timeout: l,
				location: s,
				canClose: !l || n,
				withShadow: r
			});
		},
		removeNotification: (e) => {
			B.value = B.value.filter((t) => t.id !== e);
		},
		clearNotifications: () => {
			B.value = [];
		}
	};
}
//#endregion
//#region src/components/LocationContainer/LocationContainer.vue?vue&type=script&setup=true&lang.ts
var G = ["data-test"], K = /*@__PURE__*/ u({
	__name: "LocationContainer",
	props: { location: {} },
	setup(t) {
		let { notifications: i, removeNotification: o } = W(), l = t, u = n(() => i.value.filter((e) => e.location === l.location));
		return (n, i) => (p(), a("div", { "data-test": `notifications ${t.location}` }, [(p(!0), a(e, null, g(u.value, (e) => (p(), r(z, {
			id: e.id,
			key: e.id,
			"can-close": e.canClose,
			class: "flex-none",
			size: y(N).Full,
			timeout: e.timeout,
			variant: e.variant,
			"with-shadow": e.withShadow,
			onRemove: y(o)
		}, s({
			default: S(() => [c(" " + v(e.body), 1)]),
			_: 2
		}, [e.title ? {
			name: "title",
			fn: S(() => [c(v(e.title), 1)]),
			key: "0"
		} : void 0]), 1032, [
			"id",
			"can-close",
			"size",
			"timeout",
			"variant",
			"with-shadow",
			"onRemove"
		]))), 128))], 8, G));
	}
}), q = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, J = /*#__PURE__*/ q(K, [["__scopeId", "data-v-4e672e0e"]]), Y = /* @__PURE__ */ u({
	__name: "Notification",
	props: {
		id: {},
		variant: {},
		canClose: { type: Boolean },
		withShadow: { type: Boolean },
		timeout: { default: 0 }
	},
	emits: ["remove"],
	setup(e, { emit: t }) {
		let n = t, a = h(!0), o = () => {
			a.value = !1, n("remove");
		};
		return (t, n) => a.value ? (p(), r(z, {
			key: 0,
			id: e.id,
			"can-close": e.canClose,
			class: "relative",
			"data-test": "notification",
			timeout: e.timeout,
			variant: e.variant,
			"with-shadow": e.withShadow,
			onRemove: o
		}, {
			title: S(() => [_(t.$slots, "title")]),
			default: S(() => [_(t.$slots, "default")]),
			_: 3
		}, 8, [
			"id",
			"can-close",
			"timeout",
			"variant",
			"with-shadow"
		])) : i("", !0);
	}
}), X = { class: "whitespace-pre-wrap" }, Z = /*#__PURE__*/ q(/* @__PURE__ */ u({
	__name: "NotificationContainer",
	setup(i) {
		let { t: u, te: d } = j(), { notifications: f, removeNotification: m } = W(), h = b("container"), _ = n(() => f.value.filter((e) => e.location === P.Toaster)), C = () => {
			let e = h.value;
			!e || !("showPopover" in e) || (e.matches(":popover-open") && e.hidePopover(), _.value.length > 0 && e.showPopover());
		};
		x(() => _.value.length, C), A(window, O, C);
		let w = (e) => d(e) ? u(e) : e;
		return (n, i) => (p(), a("div", {
			id: "notification__container",
			ref_key: "container",
			ref: h,
			popover: "manual"
		}, [l(t, { name: "list" }, {
			default: S(() => [(p(!0), a(e, null, g(_.value, (e) => (p(), r(z, {
				id: e.id,
				key: e.id,
				"can-close": e.canClose,
				class: "flex-none",
				size: y(N).Half,
				timeout: e.timeout,
				variant: e.variant,
				"with-shadow": e.withShadow,
				onRemove: y(m)
			}, s({
				default: S(() => [o("p", X, v(w(e.body)), 1)]),
				_: 2
			}, [e.title ? {
				name: "title",
				fn: S(() => [c(v(w(e.title)), 1)]),
				key: "0"
			} : void 0]), 1032, [
				"id",
				"can-close",
				"size",
				"timeout",
				"variant",
				"with-shadow",
				"onRemove"
			]))), 128))]),
			_: 1
		})], 512));
	}
}), [["__scopeId", "data-v-a066a1ab"]]);
//#endregion
export { J as LocationContainer, Y as Notification, Z as NotificationContainer, P as NotificationLocation, N as NotificationSize, M as NotificationVariant, W as useNotification };
